import { render, staticRenderFns } from "./ScoreBadge.vue?vue&type=template&id=6340d824&scoped=true&"
import script from "./ScoreBadge.vue?vue&type=script&lang=ts&"
export * from "./ScoreBadge.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6340d824",
  null
  
)

export default component.exports